// var $=jQuery;



$(document).on('click', '.sticky-cart__content-heading .colllection_buyout .buyout .iconfont', function () {
    // $('.m_shopcart_price').remove();
    const $popup = $('.buy-out-popup');
    console.log('弹窗获取呢绒',$popup);
    
  
    if ($popup.length === 0) {
      console.warn('弹窗未找到');
      return;
    }
  
    // 判断当前是显示还是隐藏
    if ($popup.css('display') === 'none') {
        
      console.log("当前为none1",$popup.css('display'));
      
      // 当前隐藏 → 显示并调用更新
      $popup.css('display', 'block');
      showBuyoutPopup();
  
      // 切换图标状态
      $(this).removeClass('icon-chevron-down1').addClass('icon-up');
    } else {
      console.log("当前为block2",$popup.css('display'));
      // 当前显示 → 隐藏
      $popup.css('display', 'none');
  
      // 切换图标状态
      $(this).removeClass('icon-up').addClass('icon-chevron-down1');
    }
});
console.log($('.payment-checkout-button').length,"查看结算按钮长度");


//   $('.payment-checkout-button').off("click").on("click", function (e) {
//     e.preventDefault(); // 阻止 a 标签默认跳转行为
//     console.log('点击结算按钮');  
//     // 获取参数
//     quantity = product_num;
//     skuId = $('.sku_ipt').val();
//     productId = $('.product__info-wrapper').attr('data-product-id');
//     option1 = $('variant-radios .variant-input-wrapper').eq(0).find('input:checked').val();
//     option2 = $('variant-radios .variant-input-wrapper').eq(1).find('input:checked').val();
//     option3 = $('variant-radios .variant-input-wrapper').eq(2).find('input:checked').val();
//     addCartThenCheckout();

//   });


// $('.sticky-cart .product-form__buttons .product-form-submit').off("click").on("click",function(e){

//   console.log('测试加购提交');
//    e.preventDefault(); // 阻止默认提交
//   // 遍历sku

//   quantity= product_num;
//   skuId=$('.sku_ipt').val();
//   productId=$('.product__info-wrapper').attr('data-product-id');
//   option1=$('variant-radios .variant-input-wrapper').eq(0).find('input:checked').val();
//   option2=$('variant-radios .variant-input-wrapper').eq(1).find('input:checked').val();
//   option3=$('variant-radios .variant-input-wrapper').eq(2).find('input:checked').val();
//   console.log('变体1',option1,'变体2',option2,'变体3',option3);
  
//   // product_add_cartt();
// })
$('.sticky-cart .product-form__buttons .product-form-submit')
  .off("click")
  .on("click", function (e) {
    e.preventDefault(); // 阻止默认提交
    console.log('测试加购提交');

    // 获取已选属性（可变数量）
    let selectedOptions = [];
    $('variant-radios .variant-input-wrapper').each(function () {
      const val = $(this).find('input:checked').val();
      if (val) selectedOptions.push(val);
    });

    console.log('已选择的变体属性:', selectedOptions);
    
    const product_num = $('.product-form__quantity .quantity__input').val();
    console.log("打印数量", product_num);
    
    // 获取变体 JSON 数据
    const variantJson = document.getElementById('product-variants-sku-data').textContent;
    const variants = JSON.parse(variantJson);

    // 匹配当前选择的变体
    const matchedVariant = variants.find(v =>
      selectedOptions.every((opt, index) => v[`option${index + 1}`] === opt)
    );

    if (!matchedVariant) {
      console.log('❌ 未找到匹配的变体，请检查选项');
      return;
    }

    // 获取匹配到的变体 ID
    const skuId = matchedVariant.id;
    const productId = $('.product__info-wrapper').attr('data-product-id');
    const quantity = product_num;

    // 如果无库存
    if (!matchedVariant.available) {
      console.log('❌ 当前变体无库存');
      return;
    }

    // 也可以填入 hidden input
    $('.sku_ipt').val(skuId);

    console.log('✅ 最终 SKU ID:', skuId, '产品ID:', productId, '数量:', quantity);

    // 提交加购
    product_add_cartt(
      skuId,
      matchedVariant.option1 || '',
      matchedVariant.option2 || '',
      matchedVariant.option3 || '',
      productId,
      quantity
    );
  });









$(document).on('click', '.payment-checkout-button', function (e) {
    e.preventDefault();
    console.log('点击结算按钮2222');
    var product_num=parseInt($('.product__info-wrapper #Quantity-buy_buttons').val());
    // 获取参数
    quantity = product_num;
    skuId = $('.sku_ipt').val();
    productId = $('.product__info-wrapper').attr('data-product-id');
    option1 = $('variant-radios .variant-input-wrapper').eq(0).find('input:checked').val();
    option2 = $('variant-radios .variant-input-wrapper').eq(1).find('input:checked').val();
    option3 = $('variant-radios .variant-input-wrapper').eq(2).find('input:checked').val();
    console.log("1:",quantity,"2:",skuId,"3:",productId,"4:",option1,"5:",option2,"6:",option3);

    addCartThenCheckout();
  });
  // 属性弹窗弹出
function showBuyoutPopup() {
    // 如果已经有弹窗，就不重复添加
    // if ($('.buy-out-popup').length > 0) return;
    const $popup2 = $('.buy-out-popup');
    
    // var product_num=parseInt($('.product__info-wrapper #Quantity-buy_buttons').val());
    var product_num = parseInt($('.product__info-wrapper #Quantity-buy_buttons').val()) || 1;

  
    console.log('点击出现弹窗');
    var nowPrice = $('.sticky-cart__content .now_price .money').not('.kongdiv .sticky-cart__content .now_price .money').text();
    var lastPrice = $('.sticky-cart__content .buyout_price .money').not('.kongdiv .sticky-cart__content .buyout_price .money').text();
    var savePrice = $('.sticky-cart__content .buyout_price').not('.kongdiv .sticky-cart__content .buyout_price').attr('data-saveprice');
    var savePriceNew = savePrice.replace(/[$,]/g, ''); // 去掉逗号
    var savePriceAll = '$' + (savePriceNew*product_num).toFixed(2);
    var discountPrice = $('.sticky-cart__content .buyout_price').not('.kongdiv .sticky-cart__content .buyout_price').attr('data-discount');
    var code = $('.sticky-cart__content .buyout_price').not('.kongdiv .sticky-cart__content .buyout_price').attr('data-code');
    console.log($('.sticky-cart__content .buyout_price'),"查看结构属性");
    // 去重函数
    // function deduplicatePrices(priceStr) {
    //     const prices = priceStr.trim().split(/\s+/); // 分割成数组（以空格分隔）
    //     const uniquePrices = [...new Set(prices)];  // 利用 Set 去重
    //     return uniquePrices.join(' ');              // 拼接成字符串
    // }
    // 去重处理
    // lastPrice = deduplicatePrices(lastPrice);
    // nowPrice = deduplicatePrices(nowPrice);
    console.log("打印推送数据 lastPrice:",lastPrice);
    console.log("打印推送数据 nowPrice:",nowPrice);
    
  
     // 推送获取价格到 弹窗
     jQuery('.pop_detail .popup-price-top-price.lastPrice').text(lastPrice);
     jQuery('.pop_detail .popup-price-top-price.nowPrice').text(nowPrice);
     jQuery('.pop_detail .popup-price-top-price.savePriceAll').text(savePriceAll);
     jQuery('.pop_detail .popup-price-bottom-lia.discountPrice span').text(discountPrice);
     jQuery('.pop_detail .popup-price-bottom-code.code').text(code);
     console.log();
     
   
    // $("body").append(`
    //   <div class="buy-out-popup">
    //     <div class="window-cover"></div>
    //     <div class="pop-main">
    //       <div class="pop_con">
    //         <div class="pop_title">
    //           After Code
    //           <button type="button" class="window-cover_con-close iconfont icon-x-close"></button>
    //         </div>
    //         <div class="pop_detail">
    //           <div class="popup-price">
    //             <ul class="popup-price-top">
    //               <li><div class="popup-price-top-price">${lastPrice}</div><div class="popup-price-top-word">Estimated price</div></li>
    //               <li><div class="symbol">=</div></li>
    //               <li><div class="popup-price-top-price">${nowPrice}</div><div class="popup-price-top-word">Current price</div></li>
    //               <li><div class="symbol">-</div></li>
    //               <li><div class="popup-price-top-price">${savePriceAll}</div><div class="popup-price-top-word">Best discount</div></li>
    //             </ul>
    //             <ul class="popup-price-bottom">
    //               <li class="popup-price-bottom-lia" > <span>${discountPrice}</span> OFF</li> |
    //               <li class="popup-price-bottom-lib">Code: <span class="popup-price-bottom-code">${code}</span>
    //               <i class="i-svg popup-price-bottom-svg" ><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M15.3542 8.89185C15.3542 8.36712 15.354 8.01455 15.3318 7.74333C15.3157 7.54602 15.2898 7.42591 15.2602 7.34318L15.2288 7.27157C15.1327 7.08291 14.9867 6.9251 14.8072 6.81502L14.7284 6.77116C14.6454 6.72887 14.5198 6.68972 14.2567 6.66821C13.9855 6.64605 13.6329 6.64583 13.1082 6.64583H5.68352C5.15879 6.64583 4.80622 6.64605 4.535 6.66821C4.33769 6.68434 4.21758 6.71018 4.13485 6.73983L4.06324 6.77116C3.87458 6.86731 3.71677 7.01327 3.60669 7.19279L3.56283 7.27157C3.52054 7.35456 3.48139 7.48025 3.45988 7.74333C3.43772 8.01455 3.4375 8.36712 3.4375 8.89185V16.3165C3.4375 16.8412 3.43772 17.1938 3.45988 17.465C3.48139 17.7281 3.52054 17.8538 3.56283 17.9368L3.60669 18.0155C3.71677 18.1951 3.87458 18.341 4.06324 18.4372L4.13485 18.4685C4.21758 18.4981 4.33769 18.524 4.535 18.5401C4.80622 18.5623 5.15879 18.5625 5.68352 18.5625H13.1082C13.6329 18.5625 13.9855 18.5623 14.2567 18.5401C14.5198 18.5186 14.6454 18.4795 14.7284 18.4372L14.8072 18.3933C14.9867 18.2832 15.1327 18.1254 15.2288 17.9368L15.2602 17.8652C15.2898 17.7824 15.3157 17.6623 15.3318 17.465C15.354 17.1938 15.3542 16.8412 15.3542 16.3165V8.89185ZM18.5625 15.125V8.61703C18.5625 7.57899 18.5622 6.8414 18.5151 6.26449C18.4744 5.7666 18.4014 5.43456 18.2886 5.17236L18.2376 5.06405C17.9876 4.57359 17.6076 4.16325 17.141 3.87704L16.936 3.76245C16.6569 3.62024 16.3044 3.53143 15.7355 3.48495C15.1586 3.43782 14.421 3.4375 13.383 3.4375H6.875C6.49531 3.4375 6.1875 3.1297 6.1875 2.75C6.1875 2.37031 6.49531 2.0625 6.875 2.0625H13.383C14.3983 2.0625 15.2015 2.06166 15.8474 2.11442C16.5013 2.16784 17.0547 2.27959 17.5599 2.53695L17.8598 2.70524C18.5419 3.1236 19.0978 3.72321 19.4631 4.44011L19.5526 4.63167C19.7471 5.08503 19.8388 5.58033 19.8856 6.15259C19.9383 6.79847 19.9375 7.60171 19.9375 8.61703V15.125C19.9375 15.5047 19.6297 15.8125 19.25 15.8125C18.8703 15.8125 18.5625 15.5047 18.5625 15.125ZM16.7292 16.3165C16.7292 16.8185 16.7301 17.2367 16.7023 17.5769C16.6774 17.8816 16.6267 18.1699 16.509 18.4443L16.4543 18.5607C16.2429 18.9758 15.921 19.3229 15.526 19.5651L15.3524 19.6627C15.0433 19.8201 14.7167 19.8822 14.3686 19.9106C14.0284 19.9384 13.6102 19.9375 13.1082 19.9375H5.68352C5.18148 19.9375 4.7633 19.9384 4.4231 19.9106C4.11841 19.8857 3.83011 19.835 3.55567 19.7173L3.43929 19.6627C3.02423 19.4512 2.67711 19.1293 2.4349 18.7344L2.33732 18.5607C2.17992 18.2517 2.11781 17.925 2.08936 17.5769C2.06156 17.2367 2.0625 16.8185 2.0625 16.3165V8.89185C2.0625 8.38981 2.06156 7.97163 2.08936 7.63143C2.11781 7.28334 2.17992 6.95667 2.33732 6.64762L2.4349 6.47396C2.67711 6.07905 3.02423 5.75714 3.43929 5.54566L3.55567 5.49105C3.83011 5.37335 4.11841 5.32259 4.4231 5.29769C4.7633 5.26989 5.18148 5.27083 5.68352 5.27083H13.1082C13.6102 5.27083 14.0284 5.26989 14.3686 5.29769C14.7167 5.32614 15.0433 5.38825 15.3524 5.54566L15.526 5.64323C15.921 5.88544 16.2429 6.23256 16.4543 6.64762L16.509 6.764C16.6267 7.03844 16.6774 7.32674 16.7023 7.63143C16.7301 7.97163 16.7292 8.38981 16.7292 8.89185V16.3165Z" fill="black"/></svg> </i>
    //                </li>
    //             </ul>
    //           </div>
    //         </div>
    //         <div class="pop-copied-alter gift-copied-alter ">
    //               Copy Success
    //         </div> 
    //       </div>
    //     </div>
    //   </div>
    // `);
  
    $('.sticky-cart__content-heading .colllection_buyout .buyout .iconfont').removeClass('icon-chevron-down1').addClass('icon-up');
  
    $('.buy-out-popup .window-cover_con-close').off('click').on('click',function () {
      console.log('点击关闭弹窗');
      // $('.buy-out-popup').remove();
      $popup2.css('display', 'none');
      $('.sticky-cart__content-heading .colllection_buyout .buyout .iconfont').removeClass('icon-up').addClass('icon-chevron-down1');
    });
    // ✅ 点击遮罩层关闭弹窗
    $('.buy-out-popup .window-cover').off('click').on('click',function () {
      console.log('点击遮罩关闭弹窗');
      // $('.buy-out-popup').remove();
      $popup2.css('display', 'none');
      $('.sticky-cart__content-heading .colllection_buyout .buyout .iconfont').removeClass('icon-up').addClass('icon-chevron-down1');
    });
    $('.buy-out-popup .pop-main').off('click').on('click',function (e) {
      e.stopPropagation(); // 阻止冒泡，避免触发 .window-cover 的点击
    });
    // 点击复制 并弹出弹窗
    $('.popup-price-bottom-svg').off('click').on('click', function () {
      console.log("点击复制");
    
      const $container = $(this).closest(".pop-main");
      const popupCode = $container.find('.popup-price-bottom-code').text().trim();
    
      // 把折扣码写入剪贴板
      navigator.clipboard.writeText(popupCode).then(() => {
        console.log("折扣码已复制到剪贴板:", popupCode);
    
        // 显示复制成功提示
        $container.find('.gift-copied-alter').addClass('gift-copied-alter-pos');
    
        // 2秒后隐藏提示（可选）
        setTimeout(() => {
          $container.find('.gift-copied-alter').removeClass('gift-copied-alter-pos');
        }, 2000);
      }).catch(err => {
        console.error("复制失败:", err);
      });
    });
    
    
  }


// add to cart 加购
function product_add_cartt(skuId, option1, option2, option3, productId, quantity){
  console.log("打印走加购的数量值:",quantity);
  
  fetch('/cart/add.js', {
      method:'POST',
      headers: {'Content-Type':'application/json'},
      body:JSON.stringify({
      'form_type':"product",
      'id':skuId,
      'option-0':option1,
      'option-1':option2,
      'option-2':option3,
      'product-id':productId,
      'quantity': quantity
      })
  }).then(function(response) {
      // 处理响应
      if(response) {

        window.location.href ="/cart";
        // if (showNowCheckoutUrl === 1 ) {
        //   window.location.href = "/checkout";
        // } else {
          
        //   window.location.href = "/cart";
        // }
       
      
      }else{
      $('.teast_popup img').addClass('none');
      $('.teast_popup p').text('Failed to add shopping cart');
      $(".teast_popup").removeClass('none');
      $(".teast_popup").delay(3000).fadeOut("slow");
      }
  })
  .catch(function(error) {
      console.error('Failed to add shopping cart：', error);
  });
}
  // shop now 结账加购
function addCartThenCheckout(){
    fetch('/cart/add.js', {
        method:'POST',
        headers: {'Content-Type':'application/json'},
        body:JSON.stringify({
        'form_type':"product",
        'id':skuId,
        'option-0':option1,
        'option-1':option2,
        'option-2':option3,
        'product-id':productId,
        'quantity': quantity
        })
    }).then(function(response) {
        // 处理响应
        if(response) {
          console.log("成功添加接下来跳转到结账");
          
          window.location.href ="/checkout";
        }else{
        $('.teast_popup img').addClass('none');
        $('.teast_popup p').text('Failed to add shopping cart');
        $(".teast_popup").removeClass('none');
        $(".teast_popup").delay(3000).fadeOut("slow");
        }
    })
    .catch(function(error) {
        console.error('Failed to add shopping cart：', error);
    });
  }